if (!customElements.get('product-form')) {
    customElements.define('product-form', class AddToCart extends HTMLElement {
        constructor() {
            super();

            this.form = this.querySelector('form[action$="/cart/add"]');
            this.form.querySelector('[name=id]').disabled = false;
            this.form.addEventListener('submit', this.formSubmit.bind(this)); // submit event
        }

        formSubmit(evt) {
            evt.preventDefault();

            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];
            const formData = new FormData(this.form);
            config.body = formData;

            fetch(`${routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then((response) => {
                    if (response.status) {
                        // Error function
                        this.errorMessage(response)
                        return;
                    }
                    // Succses function
                    // Update_cart_count()
                    this.succses()
                    this.removeError()
                    console.log("Succses")
                })
                .catch((error) => {
                    console.log(error);
                });
        }

        errorMessage(resp) {
            // alert(resp.description)
            const cartBox = $('.js-cart-box-section');
            if(cartBox.length > 0){
                cartBox.find('.cart-box__buttons').addClass( 'has-error');
                let errorBlock = $(`<p class=\"product-error cart-box__description-text\">${resp.description}</p>`)
                cartBox.append(errorBlock)
            }
        }
        removeError() {
            const cartBox = $('.js-cart-box-section');
            if(cartBox.length > 0){
                cartBox.find('.cart-box__buttons').removeClass( 'has-error');
                cartBox.find('.product-error').remove();
            }
        }

        succses() {
            const productCard =  this.closest('.carousel-card');
            const productForm=  true;
            if(productCard) {
                productCard.classList.add('selected');
                productCard.querySelector('button').disabled = true;
            }
            const add_to_cart_button = this.querySelector('.cart-box__button');
            if(add_to_cart_button){
                add_to_cart_button.classList.add('product-in-cart')
            }
            updateCartPopup(productForm);
            $('.js-header-cart')[0].click()
        }
    });
}
